// 税込価格
export const UPPER_MATERIALS = [
  { label: 'エナメル', value: 'enamel', price: 34155 }, // 従来より550円ずつ加算... ダブルラインのみにした影響
  { label: 'エナメルxメッシュ', value: 'enamelMesh', price: 34705 },
  { label: 'ロベニカスムース', value: 'smooth', price: 36355 },
  { label: 'ヌバック', value: 'nubuck', price: 34705 },
  { label: 'ヌバックxメッシュ', value: 'nubuckMesh', price: 35805 }
  // { label: 'スムースxメッシュ', value: 'smoothMesh', price: 31000 },
  // { label: 'ロベニカxメッシュ', value: 'robenicaMesh', price: 32000 },
  // { label: 'ロベニカxスムース', value: 'robenicaSmooth', price: 32500 }
]

export const SIZES = [
  { label: '23.5cm', value: '23.5' },
  { label: '24.0cm', value: '24' },
  { label: '24.5cm', value: '24.5' },
  { label: '25.0cm', value: '25' },
  { label: '25.5cm', value: '25.5' },
  { label: '26.0cm', value: '26' },
  { label: '26.5cm', value: '26.5' },
  { label: '27.0cm', value: '27' },
  { label: '27.5cm', value: '27.5' },
  { label: '28.0cm', value: '28' },
  { label: '28.5cm', value: '28.5' },
  { label: '29.0cm', value: '29' },
  { label: '29.5cm', value: '29.5' },
  { label: '30.0cm', value: '30' },
  { label: 'リセット', value: 'unselected' }
]

export const OPENING_PATTERNS = [
  { label: 'ローカット', value: 'lowCut', price: 0 },
  { label: 'クォーターカット', value: 'quarterCut', price: 1540 },
  { label: 'ミドルカット(山型)', value: 'mountainMiddleCut', price: 1540 },
  { label: 'ミドルカット(ストレート)', value: 'horizontalMiddleCut', price: 1540 }
]

export const VAMP_STRAP_TYPES = [
  { label: '紐式', value: 'laceType', price: 0 },
  { label: 'マジックベルト(同方向)', value: 'beltTypeSameDirection', price: 1540 },
  { label: 'マジックベルト(逆方向)', value: 'beltTypeReverseDirection', price: 1540 }
]

export const TONGUES = [
  { label: '立ちベロ', value: 'standingTongue' },
  { label: '折りベロ', value: 'foldingTongue' }
]
export const OUT_SOLES = [
  { label: '樹脂底(EVA白)', value: 'resinSoleEvaWhiteCleats', imageUrl: '/atoms/shoes/outSoles/resinSoleEvaWhiteCleats.jpg' },
  { label: 'ブロックポイント', value: 'pointSole', imageUrl: '/atoms/shoes/outSoles/pointSole.jpg' },
  { label: '革底', value: 'leatherSoleWithEva', imageUrl: '/atoms/shoes/outSoles/leatherSoleWithEva.jpg' },
  { label: 'ランニング', value: 'runningShoesSole', imageUrl: '/atoms/shoes/outSoles/runningShoesSole.jpg' },
  { label: '人工芝ソール', value: 'artificialTurfSole', imageUrl: '/atoms/shoes/outSoles/artificialTurfSole.jpg' }
]

export const doubleLine = { label: 'ダブルライン', value: 'doubleLine', price: 0 }
export const LINE_TYPES = [
  // { label: 'シングルライン', value: 'singleLine', price: 0 },
  doubleLine // 素材選択で価格を550円加算済み
]

export const TOE_GUARDS = [
  { label: '右足', value: 'rightToeGuard', price: 0 },
  { label: '左足', value: 'leftToeGuard', price: 0 },
  { label: '不要', value: 'none', price: 0 }
]

export const TOE_GUARD_KINDS = [
  { label: '投手用縫いP', value: 'forPitcher', price: 2200 },
  { label: '野手用縫いP', value: 'forFielder', price: 1980 },
  { label: '投手用縫いP(コバ金付)', value: 'forPitcherWithMetalReinforcement', price: 3300 },
  { label: '野手用縫いP(コバ金付)', value: 'forFielderWithMetalReinforcement', price: 3080 }
  // { label: '不要', value: 'none', price: 0 }
]

// export const H = [
//     { label: '', value: '' },
// ]
